import { render, staticRenderFns } from "./OptionButton.vue?vue&type=template&id=31ad4db6&"
import script from "./OptionButton.vue?vue&type=script&lang=js&"
export * from "./OptionButton.vue?vue&type=script&lang=js&"
import style0 from "./OptionButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports